/**
 * Enumeration of possible Authentication Command Response Types
 */
export const AuthenticationCommandResponses = {
    CheckAuthentication: "check-authentication-response",
    ChangePassword: "change-password-response",
    ClosePortalNavigation: "close-portal-navigation-response",
    Initialized: "initialized-response",
    Logout: "logout-response",
    ParentNavigation: "navigate-parent-response",
    PortalNavigation: "portal-navigation-response",
    RedeemCode: "redeem-code-response",
    RedirectToLogin: "redirect-to-login-response",
    RefreshTokens: "refresh-tokens-response",
    RegisterStyles: "register-styles-response",
    UpdateProfile: "update-profile-response",
};
